import "./Policy.css";

import { Breadcrumb, message, Table, type TableColumnsType } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  SectionHeader,
  TableMenuDropdown,
  UploadPolicyCsvModal,
} from "../../_lib/_components";
import {
  deletePolicy,
  getPolicies,
  type PolicyType,
  useAppSelector,
} from "../../_lib/_store";

export const PolicyPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading, policies } = useAppSelector((state) => state.policy);
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await getPolicies(messageApi);
  };

  const columns: TableColumnsType<PolicyType> = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: "Package Id",
      dataIndex: "package",
      key: "package",
      render: (_, obj) => <p>{obj?.package?.name}</p>,
    },
    {
      title: "Category Id",
      dataIndex: "category",
      key: "category",
      render: (_, obj) => <p>{obj?.category?.name}</p>,
    },
    {
      title: "Sub Category Id",
      dataIndex: "subCategoryId",
      key: "subCategoryId",
      render: (_, obj) => <p>{obj?.subCategory?.name}</p>,
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 100,
      render: (_, obj) => (
        <TableMenuDropdown onClick={(key) => handleMenuClick(key, obj)} />
      ),
    },
  ];

  const handleMenuClick = (key: string, obj: PolicyType) => {
    switch (key) {
      case "show":
        navigate(`/policy/show`, { state: { policy: obj } });
        break;
      case "edit":
        navigate(`/policy/edit`, { state: { policy: obj } });
        break;
      case "delete":
        deletePolicy(messageApi, obj?.id, true);
        break;
      default:
        break;
    }
  };

  return (
    <>
      {contextHolder}
      <div className="policy">
        <div className="header">
          <Breadcrumb
            items={[
              {
                title: <Link to="/dashboard">Dashboard</Link>,
              },
              {
                title: "Policy",
              },
            ]}
          />
          <UploadPolicyCsvModal />
        </div>
        <SectionHeader dataLength={policies?.length} createRoute="policy" />
        <Table
          sticky
          dataSource={policies}
          columns={columns}
          loading={isLoading}
          scroll={{ x: 1000 }}
          rowKey={"id"}
        />
      </div>
    </>
  );
};
